module.exports = __webpack_public_path__ + "static/media/cadamatic.3583b75b.png";